<template>
    <div class="mb-5 mt-5 p-5 bg-white rounded-xl shadow">
        <h1 class="text-xl font-bold">Proceso de anulación</h1>
        <div v-if="order.order_state == 'cancel'">
            <span class="text-red-500">PEDIDO ANULADO</span>
            Motivo: {{ order?.nulled.description }}
        </div>
        <form v-else @submit.prevent="submit">
            <textarea 
                v-model="form.description" 
                class="w-full mb-2 border rounded"
                placeholder="Ingrese el motivo de la anulación"
                name="" 
                id="" 
                cols="25" 
                rows="10">
            </textarea>
            <button type="submit" class="btn-blue bg-red-500 text-white">
                Anular
            </button>
        </form>
    </div>
</template>

<script>
    export default {
        name: 'OrderNulled',
        props: {
            order: Object
        },
        data() {
            return {
                form: this.$inertia.form({
                    description: '',
                    order_id: this.order.id
                })
            }
        },
        methods: {
            submit() {
                this.form.post('/orders/nulled')
            }
        }
    }
</script>